// Mock data for देशी Stuff website

export const menuItems = [
  // Menu items removed as per user request
];

export const outlets = [
  {
    id: 1,
    name: "Gota",
    address: "GF 34, Vandematram Cross Road, Gota, Ahmedabad - 382481",
    phone: "9601382424",
    timings: {
      monday: "6:00 PM - 12:00 AM",
      tueSun: "12:00 PM - 3:00 PM, 6:00 PM - 12:00 AM"
    },
    mapUrl: "https://maps.app.goo.gl/dMT8ACW9ydr3G9yc6"
  },
  {
    id: 2,
    name: "Vaishnodevi Circle",
    address: "GF-3, Malabar County -2, Behind Nirma University, Tragad, Ahmedabad - 382470",
    phone: "9601382424",
    timings: {
      allDays: "12:00 PM - 3:00 PM, 6:00 PM - 12:00 AM"
    },
    mapUrl: "https://maps.app.goo.gl/2Z3TK7L4mUwg19LU9"
  },
  {
    id: 3,
    name: "New Ranip",
    address: "Sardar Chowk, New Ranip, Ahmedabad - 382480",
    phone: "9601382424",
    timings: {
      monday: "6:00 PM - 12:00 AM",
      tueSun: "12:00 PM - 3:00 PM, 6:00 PM - 12:00 AM"
    },
    mapUrl: "https://maps.app.goo.gl/LqGT249eRm8AADMK7"
  },
  {
    id: 4,
    name: "Science City",
    address: "GF - 11, City Square, In front of Science City Park Main Gate, Science City Road, Sola, Ahmedabad - 380060",
    phone: "9601382424",
    timings: {
      monday: "6:00 PM - 12:00 AM",
      tueSun: "12:00 PM - 3:00 PM, 6:00 PM - 12:00 AM"
    },
    mapUrl: "https://maps.app.goo.gl/P5ZpExttKnwG5Fiu8"
  },
  {
    id: 5,
    name: "Ghatlodiya",
    address: "GF -3, Swati Complex, Near Patrol Pump, K K Nagar Road, Ghatlodiya, Ahmedabad - 380061",
    phone: "9601382424",
    timings: {
      monday: "6:00 PM - 12:00 AM",
      tueSun: "12:00 PM - 3:00 PM, 6:00 PM - 12:00 AM"
    },
    mapUrl: "https://maps.app.goo.gl/inpj3xDckNfTa3CF9"
  },
  {
    id: 6,
    name: "Motera",
    address: "GF -3, Vitthal Vibrant, Behind Sangath Mall, Motera, Ahmedabad - 380005",
    phone: "9601382424",
    timings: {
      allDays: "6:00 PM - 12:00 AM"
    },
    mapUrl: "https://maps.app.goo.gl/yAfY4AjVT9eBqVNC7"
  }
];

export const socialLinks = {
  instagram: "https://share.google/BMGoR39q7VH0GMssy",
  zomato: "https://zomato.onelink.me/xqzv/y011y63v"
};

export const brandLogo = "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/xyv5xygv_IMG_20260412_095859.jpg";

export const tagline = "हम आपको वो ही खिलाते हैं, जो हम खुद खा सकते हैं।";

export const testimonials = [
  {
    id: 1,
    name: "Rahul Patel",
    location: "Gota",
    text: "Best parathas in Ahmedabad! The butter and stuffing is just perfect. Been coming here for 6 months now.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Shah",
    location: "Vaishnodevi Circle",
    text: "Fresh, hygienic, and tasty! Great value for money. My family's favorite place!",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Desai",
    location: "Science City",
    text: "Authentic Punjabi taste! Reminds me of home-made parathas. Quick service too.",
    rating: 5
  }
];

export const franchiseData = {
  investmentRange: "₹16-22 Lakhs",
  models: "FOCO & FOFO Models Available",
  benefits: [
    "Established brand name & recognition",
    "Complete training & operational support",
    "Centralized supply chain management",
    "Marketing & social media support",
    "Proven business model with growing demand"
  ],
  requirements: [
    "400-600 sq ft space in high footfall area",
    "Investment capacity: ₹16-22 lakhs",
    "Commitment to maintain quality standards",
    "Business mindset with customer focus"
  ],
  contact: "9601382424"
};

export const heroImages = [
  "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/l5cguylb_IMG_20260412_084343.jpg",
  "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/nj3eng9d_IMG_20260412_084510.jpg",
  "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/n98suoov_IMG_20260412_084533.jpg",
  "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/l9f1l6lr_IMG_20260412_084557.jpg"
];

export const aboutImages = [
  "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/qkkdhicg_IMG_20260412_084446.jpg",
  "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/9fakwnqm_IMG_20260412_090329.jpg",
  "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/qptbll7s_IMG_20260412_085114.jpg"
];

export const foodImages = [
  "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/l5cguylb_IMG_20260412_084343.jpg",
  "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/nj3eng9d_IMG_20260412_084510.jpg",
  "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/n98suoov_IMG_20260412_084533.jpg",
  "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/l9f1l6lr_IMG_20260412_084557.jpg"
];

export const menuBoardImages = [
  "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/t91qop8y_07-08-2025%20science%20city%2002.jpg",
  "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/dmfg42gp_07-08-2025%20science%20city%2002%281%29.jpg"
];

export const beverageImage = "https://customer-assets.emergentagent.com/job_desi-paratha-hub/artifacts/hzqsfrj9_IMG_20260412_084920.jpg";
